// ISO2 code -> nome in italiano
export const COUNTRIES = [
  { code: "IT", name: "Italia" },
  { code: "DE", name: "Germania" },
  { code: "FR", name: "Francia" },
  { code: "ES", name: "Spagna" },
  { code: "GB", name: "Regno Unito" },
  { code: "CH", name: "Svizzera" },
  { code: "AT", name: "Austria" },
  { code: "NL", name: "Paesi Bassi" },
  { code: "BE", name: "Belgio" },
  { code: "PT", name: "Portogallo" },
  { code: "IE", name: "Irlanda" },
  { code: "SE", name: "Svezia" },
  { code: "NO", name: "Norvegia" },
  { code: "DK", name: "Danimarca" },
  { code: "FI", name: "Finlandia" },
  { code: "PL", name: "Polonia" },
  { code: "CZ", name: "Repubblica Ceca" },
  { code: "SK", name: "Slovacchia" },
  { code: "HU", name: "Ungheria" },
  { code: "RO", name: "Romania" },
  { code: "BG", name: "Bulgaria" },
  { code: "GR", name: "Grecia" },
  { code: "HR", name: "Croazia" },
  { code: "SI", name: "Slovenia" },
  { code: "RS", name: "Serbia" },
  { code: "LU", name: "Lussemburgo" },
  { code: "MT", name: "Malta" },
  { code: "CY", name: "Cipro" },
  { code: "EE", name: "Estonia" },
  { code: "LV", name: "Lettonia" },
  { code: "LT", name: "Lituania" },
  { code: "IS", name: "Islanda" },
  { code: "AL", name: "Albania" },
  { code: "MK", name: "Macedonia del Nord" },
  { code: "BA", name: "Bosnia ed Erzegovina" },
  { code: "ME", name: "Montenegro" },
  { code: "UA", name: "Ucraina" },
  { code: "TR", name: "Turchia" },
  { code: "RU", name: "Russia" },
  { code: "US", name: "Stati Uniti" },
  { code: "CA", name: "Canada" },
  { code: "MX", name: "Messico" },
  { code: "BR", name: "Brasile" },
  { code: "AR", name: "Argentina" },
  { code: "CL", name: "Cile" },
  { code: "CO", name: "Colombia" },
  { code: "PE", name: "Perù" },
  { code: "UY", name: "Uruguay" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "Nuova Zelanda" },
  { code: "JP", name: "Giappone" },
  { code: "CN", name: "Cina" },
  { code: "IN", name: "India" },
  { code: "SG", name: "Singapore" },
  { code: "HK", name: "Hong Kong" },
  { code: "KR", name: "Corea del Sud" },
  { code: "ID", name: "Indonesia" },
  { code: "MY", name: "Malaysia" },
  { code: "TH", name: "Thailandia" },
  { code: "PH", name: "Filippine" },
  { code: "VN", name: "Vietnam" },
  { code: "AE", name: "Emirati Arabi Uniti" },
  { code: "SA", name: "Arabia Saudita" },
  { code: "QA", name: "Qatar" },
  { code: "IL", name: "Israele" },
  { code: "EG", name: "Egitto" },
  { code: "ZA", name: "Sudafrica" },
  { code: "NG", name: "Nigeria" },
  { code: "KE", name: "Kenya" },
  { code: "MA", name: "Marocco" },
  { code: "TN", name: "Tunisia" },
];

const _MAP = COUNTRIES.reduce((acc, c) => { acc[c.code] = c.name; return acc; }, {});
export const countryName = (code) => _MAP[code] || code;
